<template>
    <div class="row">
        <div class="col-sm-12">
            <h3>{{$t('components.administration.nav.failed-orders')}}</h3>
            <div class="row mt-3 mb-5">
                <div class="col-sm-12 col-md">
                    <button :class="['btn w-100', current === 'HANGING' ? 'btn-wellis-gold text-white' : 'btn-outline-wellis-gold']"
                            @click="fetch()">
                        {{$t('components.administration.failed-orders.status.HANGING')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md">
                    <button :class="['btn w-100', current === 'RESOLVED' ? 'btn-wellis-gold text-white' : 'btn-outline-wellis-gold']"
                            @click="fetch('RESOLVED')">
                        {{$t('components.administration.failed-orders.status.RESOLVED')}}
                    </button>
                </div>
                <div class="col-sm-12 col-md">
                    <button :class="['btn w-100', current === 'DELETED' ? 'btn-wellis-gold text-white' : 'btn-outline-wellis-gold']"
                            @click="fetch('DELETED')">
                        {{$t('components.administration.failed-orders.status.DELETED')}}
                    </button>
                </div>
            </div>
            <table class="table table-hover table-striped">
                <thead>
                <tr>
                    <th></th>
                    <th>Id</th>
                    <th>{{$t('components.administration.failed-orders.orderNo')}}</th>
                    <th>{{$t('components.administration.failed-orders.ifsOrderNo')}}</th>
                    <th>{{$t('components.administration.failed-orders.phase')}}</th>
                    <th>{{$t('components.administration.category.status')}}</th>
                    <th>{{$t('components.administration.failed-orders.createdAt')}}</th>
                    <th>{{$t('components.administration.failed-orders.updatedAt')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td>
                        <router-link class="btn btn-sm btn-wellis-black text-white"
                                     :to="{name: 'app.admin.orders.failed.concrete', params: {failedOrderId: item.id}}">
                            <i class="fa fa-eye"></i>
                        </router-link>
                    </td>
                    <td>#{{item.id}}</td>
                    <td class="text-center">{{item.order_id}}</td>
                    <td>{{item.ifs_order_no || '-'}}</td>
                    <td>{{item.phase}}</td>
                    <td>{{$t('components.administration.failed-orders.status')[item.objstate]}}</td>
                    <td>{{item.created_at | formatDate(true)}}</td>
                    <td>{{item.updated_at | formatDate(true)}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import OrdersApiService from "@/api/orders.api";

export default {
    name: "FailedOrderOverview",

    created() {
        this.fetch();
    },

    data() {
        return {
            current: 'HANGING',
            items: []
        }
    },

    methods: {
        async fetch(objstate = 'HANGING') {
            return new Promise((resolve, reject) => {
                let loader = this.$loading.show();
                OrdersApiService.failed.get(objstate)
                    .then(response => {
                        this.items = response.data.items;
                        this.current = objstate;
                        resolve(response.data);
                    })
                    .catch(error => {
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('api-error')
                        });
                        reject(error);
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            });
        }
    }
}
</script>

<style scoped>

</style>
